var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 15.6667H31M9.33333 29H22.6667M12.6667 22.3333L11.8333 29M19.3333 22.3333L20.1667 29M1 2.66667C1 2.22464 1.17559 1.80072 1.48816 1.48816C1.80072 1.17559 2.22464 1 2.66667 1H29.3333C29.7754 1 30.1993 1.17559 30.5118 1.48816C30.8244 1.80072 31 2.22464 31 2.66667V20.6667C31 21.1087 30.8244 21.5326 30.5118 21.8452C30.1993 22.1577 29.7754 22.3333 29.3333 22.3333H2.66667C2.22464 22.3333 1.80072 22.1577 1.48816 21.8452C1.17559 21.5326 1 21.1087 1 20.6667V2.66667Z",
    stroke: "var(--brand-color)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffice);
export default __webpack_public_path__ + "static/media/office.f994287d3271211194ad670683a50846.svg";
export { ForwardRef as ReactComponent };